<div [ngClass]="{ 'new-style': newStyle, 'more-elements__wrapper pager-href pagination__wrapper': true }">
  <ng-container>
    <ul class="pagination">
      <ng-container *ngIf="hasPreviousPage()">
        <li><a (click)="prevPage()" class="pagination__item pagination__item--prev move-to-page"></a></li>
      </ng-container>

      <ng-container *ngFor="let paginationItem of preparePagination();">
        <li>
          <ng-container *ngIf="!paginationItem.hidden; else dotBlock">
            <a (click)="changePage(paginationItem.pageNumber)"
               [routerLink]="[]"
               [queryParams]="{ page: paginationItem.pageNumber }"
               [class.active]="activePage === paginationItem.pageNumber"
               class="pagination__item pagination__item move-to-page">
              {{ paginationItem.pageNumber }}
            </a>
          </ng-container>

          <ng-template #dotBlock>
            <span class="pagination__item disabled">...</span>
          </ng-template>
        </li>
      </ng-container>

      <ng-container *ngIf="hasNextPage()">
        <li><a (click)="nextPage()" class="pagination__item pagination__item--next move-to-page"></a></li>
      </ng-container>
    </ul>
  </ng-container>


  <!--  Кнопка наверх -->
  <div *ngIf="upButton" class="pagination-button-top">
    <div class="">
      <button type="button" class="pagination__pages__button mr-md-0" (click)="up()">
        {{ upButtonText }}<i class="i shevron-up up-button__i"></i>
      </button>
    </div>
  </div>
</div>
